import React from 'react';
import classnames from 'classnames';
import { Col } from 'react-bootstrap';
import '../styles/index.scss';
const defaultProps = {
  mediaLeft: true,
  hasShadow: true,
  hasMedia: false
};
const TextBlock = _ref => {
  let {
    heading,
    content,
    mediaLeft,
    hasShadow,
    hasMedia
  } = _ref;
  const xsTextColStyling = {
    span: 12,
    order: 1
  };
  let lgTextColStyling = {
    offset: mediaLeft ? 0 : 1,
    order: mediaLeft ? 1 : 0,
    span: 5
  };
  if (!hasMedia) {
    lgTextColStyling = {
      offset: 1,
      span: 10
    };
  }
  const colShadowStyling = classnames({
    'p-0': true,
    'shadow-right': hasMedia && hasShadow && mediaLeft,
    'shadow-left': hasMedia && hasShadow && !mediaLeft
  });
  const textWithShadowStyling = classnames({
    'p-3 px-4 content-block-text': true,
    'mr-lg-5': hasMedia && hasShadow && mediaLeft,
    'ml-lg-5': hasMedia && hasShadow && !mediaLeft
  });
  const headingContentStyling = classnames({
    'content-block-heading': true,
    'no-media': !hasMedia
  });
  const textContentStyling = classnames({
    'content-block-base': true,
    'no-media': !hasMedia
  });
  return /*#__PURE__*/React.createElement(Col, {
    "data-testid": "text-container",
    xs: xsTextColStyling,
    lg: lgTextColStyling,
    className: colShadowStyling
  }, /*#__PURE__*/React.createElement("div", {
    className: textWithShadowStyling
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": "content-block-heading",
    className: headingContentStyling
  }, heading), /*#__PURE__*/React.createElement("div", {
    "data-testid": "content-block-text",
    className: textContentStyling
  }, content)));
};
TextBlock.defaultProps = defaultProps;
export { TextBlock };